import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import CustomModal from "../Modal";
import { useToggleState } from "../../../Hooks/useToggleState";
import { BASE_URL_IMAGE } from "../../../Api/client";

const CustomFileUpload = ({
   id,
   name,
   label,
   value,
   onChange,
   disabled,
   errors,
   message,
   multiple,
   require,
   accept,
}) => {
   const [isImageModalVisible, handleShowImageModal, handleCloseImageModal] =
      useToggleState();

   const handleFileChange = (e) => {
      const uploadedFile = e.target.files[0];

      if (onChange) {
         onChange(e, uploadedFile);
      }
   };

   function getDocumentURL(document) {
      let url = "";
      if (document && typeof document === "object") {
         url = URL.createObjectURL(document);
      } else {
         url = `${BASE_URL_IMAGE}${value}`;
      }
      return url;
   }

   const handleCloseModal = () => {
      handleCloseImageModal();
   };

   return (
      <div class="form-group w-100">
         <CustomModal
            showModal={isImageModalVisible}
            handleCloseModal={handleCloseModal}
            hideFooter={true}
            modalSize="modal-xl"
            modalHeight="80vh"
            title="View Document"
            // onSubmit={handleAgreementDocumentUpdate}
            child={
               <div>
                  {/* <img
                     // src={getDocumentURL(value)}
                     style={{ width: "100%", height: "100%" }}
                  /> */}
                  <object
                     data={getDocumentURL(value)}
                     style={{ width: "100%", height: "70vh" }}
                  ></object>
               </div>
            }
         />
         {label && (
            <label className="text-capitalize" htmlFor={id}>
               {label}
               {require && <span className="text-danger">*</span>}
            </label>
         )}
         <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <input
               type="file"
               id={id}
               name={name}
               className="form-control h-auto"
               onChange={handleFileChange}
               disabled={disabled}
               multiple={multiple}
               accept={accept}
            />
            {value && (
               <Button variant="contained" style={{}} onClick={handleShowImageModal}>
                  View
               </Button>
            )}
         </Box>
         {errors && (
            <div className="text-danger" style={{ fontSize: ".8rem" }}>
               {message}
            </div>
         )}
      </div>
   );
};

export default CustomFileUpload;
